import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getDashboardStatistics } from '../../utils/apiHelper';
import InfoTooltip from './InfoTooltip';
import { format, formatDistanceToNow } from 'date-fns';
import { tr } from 'date-fns/locale';

const RecentActivity = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getDashboardStatistics.recentActivity();
        if (res?.success) setData(res.statistics);
      } catch (err) {
        console.error('Recent activity error:', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Merge and sort all activities by date
  const activities = React.useMemo(() => {
    if (!data) return [];
    const items = [];

    (data.newSubscriptions || []).forEach(s => {
      items.push({
        type: 'new',
        text: `${s.customerName} yeni abonelik başlattı`,
        meta: s.plan === 'FREE' ? 'Ücretsiz' : `${s.amount?.toLocaleString('tr-TR')} ₺`,
        date: new Date(s.date)
      });
    });

    (data.recentDeliveries || []).forEach(d => {
      items.push({
        type: 'delivery',
        text: `${d.customerName} siparişi teslim edildi`,
        meta: `${d.amount?.toLocaleString('tr-TR')} ₺`,
        date: new Date(d.deliveryDate || d.date)
      });
    });

    (data.recentCancellations || []).forEach(c => {
      items.push({
        type: 'cancel',
        text: `${c.customerName} aboneliğini iptal etti`,
        meta: c.reason || 'Sebep belirtilmemiş',
        date: new Date(c.date)
      });
    });

    return items.sort((a, b) => b.date - a.date).slice(0, 8);
  }, [data]);

  const formatRelative = (date) => {
    try {
      return formatDistanceToNow(date, { addSuffix: true, locale: tr });
    } catch {
      return format(date, 'dd MMM', { locale: tr });
    }
  };

  return (
    <div className="detail-panel">
      <div className="detail-panel-header">
        <div className="detail-panel-title">
          <i className="fas fa-stream me-2" style={{ color: '#6b7280' }}></i>
          Son Aktiviteler
          <InfoTooltip text="Son abonelikler, teslimatlar ve iptaller kronolojik sırada birleştirilmiştir." />
        </div>
        <Link to="/admin/orders" className="detail-panel-link">
          Tümü →
        </Link>
      </div>
      <div className="detail-panel-body" style={{ padding: '0.5rem 1.25rem' }}>
        {loading ? (
          <div className="section-loading"><div className="spinner-border spinner-border-sm" role="status"></div></div>
        ) : activities.length === 0 ? (
          <div className="py-4 text-center text-muted small">Henüz aktivite yok</div>
        ) : (
          <ul className="activity-timeline">
            {activities.map((item, i) => (
              <li key={i} className="activity-item">
                <span className={`activity-dot ${item.type}`}></span>
                <div className="activity-content">
                  <div className="activity-text">{item.text}</div>
                  <div className="activity-meta">
                    {item.meta} · {formatRelative(item.date)}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;
